<template>
  <el-card class="app-settings" shadow="hover">
    <template v-if="type === 'textarea'">
      <div slot="header">
        <h4><slot name="title" /></h4>
      </div>
      <el-input
        v-model="localValue"
        :type="type"
        :placeholder="placeholder"
        :autosize="autosize"
        :maxlength="maxlength"
        :show-word-limit="maxlength && maxlength > 0"
      />
    </template>

    <el-row
      v-else
      type="flex"
      justify="center"
      align="middle"
      :gutter="35"
    >
      <el-col :span="16">
        <h4><slot name="title" /></h4>
        <p><slot /></p>
      </el-col>

      <el-col :span="8" align="center">
        <el-switch
          v-if="on"
          v-model="localValue"
          active-text="ON"
          inactive-text="OFF"
          :active-value="on"
          :inactive-value="off"
          :disabled="!available"
        />

        <el-select
          v-else-if="options"
          v-model="localValue"
          :disabled="!available"
        >
          <el-option
            v-for="opt in options"
            :key="opt"
            :label="opt"
            :value="opt"
          />
        </el-select>

        <template v-else-if="enable">
          <span v-if="enabled" v-html="enabled" />

          <el-button
            v-else
            type="primary"
            size="small"
            :loading="loading"
            :disabled="!available"
            @click.prevent="doEnable"
          >
            Enable
          </el-button>
        </template>

        <el-input
          v-else
          v-model="localValue"
          :type="type"
          :placeholder="placeholder"
          :disabled="!available"
        />

        <div v-if="!available" class="unavailable" v-text="unavailableText" />
      </el-col>
    </el-row>
  </el-card>
</template>

<script>
export default {
  props: {
    value: [String, Number, Boolean],
    enabled: [String, Boolean],
    enable: Function,
    on: String,
    off: String,
    placeholder: String,
    unavailableText: String,
    type: {
      type: String,
      default: 'text'
    },
    autosize: {
      type: Object,
      default: () => ({})
    },
    options: {
      type: Array,
      default: null
    },
    maxlength: {
      type: Number,
      default: null
    },
    available: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      localValue: this.value,
      loading: false
    }
  },
  methods: {
    doEnable () {
      this.loading = true
      this.enable().then(() => {
        this.loading = false
      }).catch(() => {
        this.loading = false
        this.$notify({
          title: 'Error',
          message: 'this action failed',
          type: 'error'
        })
      })
    }
  },
  watch: {
    localValue (value) {
      this.$emit('input', value)
    },
    value (value) {
      this.value = value
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../theme";

.app-settings {
  margin-bottom: 15px;

  h4 {
    margin-top: 15px;
    margin-bottom: 0;
  }
  p {
    font-size: 14px;
  }
  .el-col:first-child {
    border-right: 1px solid $--border-color-base;
  }
  .el-select {
    width: 100%;
  }
  .unavailable {
    color: $--color-danger;
    font-size: 11px;
    margin-top: 10px;
  }
}
</style>

<style lang="scss">
.app-settings {
  .el-card__header {
    padding: 15px !important;

    h4 {
      margin-top: 0;
    }
  }
  .el-card__body {
    padding: 0 20px !important;
  }
  .el-card__header + .el-card__body {
    padding: 20px !important;
  }
}
</style>
